import React, { useMemo } from 'react';
import { Role } from '../../../types/permissions';
import Select from '../../ui/Input/Select';

interface RoleSelectorProps {
  roles: Role[];
  selectedRole: Role | null;
  onRoleChange: (role: Role | null) => void;
}

// Función para capitalizar las iniciales de cada palabra
const capitalizeWords = (str: string): string => {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const RoleSelector: React.FC<RoleSelectorProps> = ({
  roles,
  selectedRole,
  onRoleChange
}) => {
  // Convertir roles a formato SelectOption y ordenar alfabéticamente
  const roleOptions = useMemo(() => {
    const rolesList = roles
      .map(role => ({
        value: role.id,
        label: capitalizeWords(role.name)
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
    
    return [
      { value: '', label: 'Selecciona un rol' },
      ...rolesList
    ];
  }, [roles]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const roleId = e.target.value ? parseInt(e.target.value) : null;
    const role = roleId ? roles.find(r => r.id === roleId) : null;
    onRoleChange(role || null);
  };

  return (
    <div className="flex items-center">
      <Select
        value={selectedRole?.id?.toString() || ''}
        onChange={handleChange}
        options={roleOptions}
        className="w-72"
      />
    </div>
  );
};

export default RoleSelector;
